import styled from "styled-components";

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RadioOption = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const RadioInput = styled.input`
  width: 18px;
  height: 18px;
  margin: 0;
  cursor: pointer;
  accent-color: #1976d2;
`;

export const RadioLabel = styled.label`
  font-size: 14px;
  color: #333;
  cursor: pointer;
  user-select: none;
`;
